import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {injectIntl} from 'react-intl';
import SelectInput from '../../components/inputs/select_input';
import Util from '../../forecast-app/shared/util/util';
import UpdateTaskMutation from '../../mutations/update_task_mutation.modern';
import UpdateProjectMutation from '../../mutations/update_project_mutation.modern';

class columnSelectionModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selection: null,
		};
	}

	handleSelectionChange(selection) {
		this.setState({
			selection: selection.value,
		});
	}

	setProjectToDone() {
		Util.CommitMutation(UpdateProjectMutation, {project: this.props.viewer.project, status: 'DONE'});
		this.props.closeModal();
	}

	moveTasksToDone() {
		const notDoneTasks = this.props.viewer.project.tasks.edges.filter(task => task.node.statusColumn.category !== 'DONE');
		const notDoneIds = notDoneTasks.map(task => task.node.id);
		Util.CommitMutation(UpdateTaskMutation, {
			ids: notDoneIds,
			statusColumnId: this.state.selection,
			statusColumnCategory: 'DONE',
		});
		this.setProjectToDone();
	}

	render() {
		const doneColumns = this.props.viewer.project.statusColumns.filter(column => column.category === 'DONE');
		const {formatMessage} = this.props.intl;
		return (
			<div className="layer" onMouseDown={this.props.closeModal}>
				<div className="column-selection-modal">
					<div
						className="column-selection-container"
						onMouseDown={e => {
							e.stopPropagation();
						}}
					>
						<div className="content">
							<div className="header">
								<h2>{formatMessage({id: 'column_selection_modal.title'})}</h2>
								<button className="close-button" onClick={this.props.closeModal} />
							</div>
							{formatMessage({id: 'column_selection_modal.description'})}
							<SelectInput
								options={doneColumns.map(column => ({value: column.id, label: column.name}))}
								onChange={this.handleSelectionChange.bind(this)}
								value={this.state.selection}
								multi={false}
								label={formatMessage({id: 'bulk_update_modal.status_placeholder'})}
							/>
						</div>
						<div className="controls">
							<button className="button-secondary" onClick={this.setProjectToDone.bind(this)}>
								{formatMessage({id: 'column_selection_modal.no-move-cards'})}
							</button>
							<button
								className="button-primary"
								onClick={this.moveTasksToDone.bind(this)}
								disabled={!this.state.selection}
							>
								{formatMessage({id: 'column_selection_modal.move-cards'})}
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const columnSelectionModalQuery = graphql`
	query columnSelectionModal_Query($projectId: String) {
		viewer {
			actualPersonId
			component(name: "column_selection_modal")
			...columnSelectionModal_viewer @arguments(projectId: $projectId)
		}
	}
`;

export {columnSelectionModalQuery};

export default injectIntl(
	createFragmentContainer(columnSelectionModal, {
		viewer: graphql`
			fragment columnSelectionModal_viewer on Viewer @argumentDefinitions(projectId: {type: "String"}) {
				id
				project(id: $projectId) {
					id
					statusColumns {
						id
						name
						category
					}
					tasks(first: 100000, includeDone: false) {
						edges {
							node {
								id
								name
								statusColumn {
									id
									name
									category
								}
							}
						}
					}
				}
			}
		`,
	})
);
